import * as actions from '../actionTypes/CheckoutActionTypes';

export default function checkoutSectionReducer(state = {}, action) {
    // NOSONAR
    switch (
        action.type // NOSONAR
    ) {
        case actions.INIT_NEW_CHECKOUT_SECTIONS:
            return action.payload;
        default:
            return state;
    }
}
